import api, { apiSetup } from '../api';

apiSetup();

export class ProjectService {
  BASE_URL = '/actions';

  get_projects_list_extra_data(filters) {
    return api.get(`${this.BASE_URL}/index_extra_data/${filters}`);
  }
}
